import PropTypes from 'prop-types'

export const sanityLibraryLinkPropTypes = {
  _type: PropTypes.oneOf(['libraryLink']),
  reference: PropTypes.shape({
    slug: PropTypes.shape({
      current: PropTypes.string,
    }),
  }),
}

export type SanityLibraryLinkProps = PropTypes.InferProps<typeof sanityLibraryLinkPropTypes>
